import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, LANGUAGE_INFO } from './i18n/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import ComingSoon from './pages/ComingSoon';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import ProductDetail from './pages/ProductDetail';
import Certificates from './pages/Certificates';
import Dealers from './pages/Dealers';
import AyakAnalizi from './pages/AyakAnalizi';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import PodologDegerlendirme from './pages/PodologDegerlendirme';
import PediZoneClips from './components/PediZoneClips';

function App() {
  // Load rrweb scripts only in staging/preview/development environments
  useEffect(() => {
    // Method 1: Check environment variable (preferred)
    const appEnvironment = process.env.REACT_APP_ENVIRONMENT;
    
    // Method 2: Fallback to hostname detection
    const hostname = window.location.hostname;
    const isProductionHostname = hostname === 'pedizone.com' || 
                                 hostname === 'www.pedizone.com';
    
    // Determine if we should load rrweb
    const shouldLoadRrweb = appEnvironment 
      ? appEnvironment !== 'production'  // Use env variable if available
      : !isProductionHostname;            // Fallback to hostname check
    
    if (shouldLoadRrweb) {
      // Load rrweb library
      const rrwebScript = document.createElement('script');
      rrwebScript.src = 'https://unpkg.com/rrweb@latest/dist/rrweb.min.js';
      rrwebScript.async = true;
      document.head.appendChild(rrwebScript);
      
      // Load rrweb recorder
      const recorderScript = document.createElement('script');
      recorderScript.src = 'https://d2adkz2s9zrlge.cloudfront.net/rrweb-recorder-20250919-1.js';
      recorderScript.async = true;
      document.head.appendChild(recorderScript);
      
      console.log('✅ rrweb loaded', {
        environment: appEnvironment || 'detected from hostname',
        hostname: hostname,
        mode: appEnvironment || (isProductionHostname ? 'production' : 'staging/preview')
      });
    } else {
      console.log('🚫 rrweb disabled (production mode)', {
        environment: appEnvironment,
        hostname: hostname
      });
    }
  }, []);

  return (
    <HelmetProvider>
      <div className="App" style={{ margin: 0, padding: 0, border: 'none' }}>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
          {/* SINGLE LANGUAGE MODE: All routes under root (/) */}
          
          {/* Main routes - TR content at root */}
          <Route path="/" element={<TRContent page="" />} />
          <Route path="/blog" element={<TRContent page="blog" />} />
          <Route path="/blog/:slug" element={<TRContent page="blog" />} />
          <Route path="/urun/:slug" element={<TRContent page="urun" />} />
          <Route path="/sertifikalar" element={<TRContent page="sertifikalar" />} />
          <Route path="/bayiler" element={<TRContent page="bayiler" />} />
          <Route path="/ayak-analizi" element={<TRContent page="ayak-analizi" />} />
          <Route path="/podolog-degerlendirmesi" element={<TRContent page="podolog-degerlendirmesi" />} />
          <Route path="/iletisim" element={<TRContent page="iletisim" />} />
          <Route path="/sss" element={<TRContent page="sss" />} />
          <Route path="/gizlilik-politikasi" element={<TRContent page="gizlilik-politikasi" />} />
          <Route path="/kullanim-sartlari" element={<TRContent page="kullanim-sartlari" />} />
          <Route path="/clips" element={<PediZoneClips />} />
          
          {/* Legacy redirects from old multi-language structure */}
          <Route path="/tr" element={<Navigate to="/" replace />} />
          <Route path="/tr/*" element={<LegacyTRRedirect />} />
          
          {/* EN & DE - Coming Soon (not linked yet) */}
          <Route path="/en" element={<ComingSoon />} />
          <Route path="/en/*" element={<ComingSoon />} />
          <Route path="/de" element={<ComingSoon />} />
          <Route path="/de/*" element={<ComingSoon />} />
        </Routes>
      </BrowserRouter>
    </div>
  </HelmetProvider>
  );
}

// TR Content wrapper - renders pages at root level
const TRContent = ({ page }) => {
  const { slug } = useParams();
  
  const renderPage = () => {
    switch (page) {
      case '':
        return <Home />;
      case 'blog':
        return slug ? <BlogDetail /> : <Blog />;
      case 'urun':
        return <ProductDetail />;
      case 'sertifikalar':
        return <Certificates />;
      case 'bayiler':
        return <Dealers />;
      case 'ayak-analizi':
        return <AyakAnalizi />;
      case 'podolog-degerlendirmesi':
        return <PodologDegerlendirme />;
      case 'iletisim':
        return <Contact />;
      case 'gizlilik-politikasi':
        return <PrivacyPolicy />;
      case 'kullanim-sartlari':
        return <TermsOfService />;
      case 'sss':
        return <FAQ />;
      default:
        return <Home />;
    }
  };

  return (
    <LanguageProvider>
      <Header />
      <main>
        {renderPage()}
      </main>
      <Footer />
      <WhatsAppButton />
    </LanguageProvider>
  );
};

// Redirect /tr/* to root /*
const LegacyTRRedirect = () => {
  const location = window.location.pathname;
  const newPath = location.replace(/^\/tr/, '');
  return <Navigate to={newPath || '/'} replace />;
};
// deploy trigger

export default App;
